import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from './attachmentFields.generated';
export type RequirementFieldsToAssignRequirementFragment = { __typename?: 'Requirement', id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, modifiedAt?: any | null, version?: string | null, definition?: string | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', name: string }> }>, documentReferences?: Array<{ __typename?: 'DocumentReference', reference?: { __typename?: 'Reference', name: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, childrenRefs?: Array<{ __typename?: 'Requirement', id: string, version?: string | null }> | null };

export const RequirementFieldsToAssignRequirementFragmentDoc = gql`
    fragment RequirementFieldsToAssignRequirement on Requirement {
  id
  name
  requirementId
  status
  category
  createdBy {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
  modifiedAt
  version
  tags {
    id
    name
  }
  attachments {
    ...AttachmentFields
  }
  keywords {
    id
    name
    vexClusters {
      id
      name
    }
    vkos {
      name
    }
  }
  documentReferences {
    reference {
      name
    }
    requirementReferences {
      id
      name
    }
  }
  vexClusters {
    id
    name
  }
  definition
  markets {
    id
    name
  }
  systemLevels {
    id
    name
  }
  childrenRefs {
    id
    version
  }
}
    ${AttachmentFieldsFragmentDoc}`;